import axios from 'axios';
// config
import { BASE_URL } from '../../config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: BASE_URL });

export const AUTH_HEADER_KEY = "jwt"
export const LANGUAGE_HEADER_KEY = "X-User-Language"

export const setAxiosAuth = (accessToken) => {
  axiosInstance.defaults.headers.common[AUTH_HEADER_KEY] = `${accessToken}`;
}

export const removeAxiosAuth = () => {
  delete axiosInstance.defaults.headers.common[AUTH_HEADER_KEY];
}

export const setAxiosLanguage = (language) => {
  axiosInstance.defaults.headers.common[LANGUAGE_HEADER_KEY] = language;
}

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Pass canceled requests through as-is so callers can check e.code === 'ERR_CANCELED'
    if (axios.isCancel(error)) return Promise.reject(error);

    const errorDetails = {
      message: error.message || `failed_request: ${error.config?.method?.toUpperCase()}:${error.config?.url}`,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      config: {
        url: error.config?.url,
        method: error.config?.method,
        // headers intentionally omitted — they contain the JWT auth token
      },
    };

    // Log the error for debugging — unless the caller declared the failure to be an ordinary
    // outcome it renders itself (`skipErrorLog: true` in the request config). Opt-in per call:
    // the default stays "log everything", and the rejection is unchanged either way, so a caller
    // that sets it still gets the same error object.
    if (!error.config?.skipErrorLog) {
      console.error('failed_request:', JSON.stringify(errorDetails));
    }

    // Create a new Error with the serialized details
    const serializedError = new Error(JSON.stringify(errorDetails));
    serializedError.originalError = error;
    serializedError.details = errorDetails;
    serializedError.userFacingMessage = errorDetails.data?.userFacingMessage || errorDetails.data?.message

    return Promise.reject(serializedError);
  }
);

export default axiosInstance;
